import type { FC } from 'react'

import type { Locale } from '@skytech/types'

import { useLocalDate } from '@/hooks/use-local-date'

export const LocalDate: FC<{ date: string; locale?: Locale }> = ({ date, locale }) => {
  const { formatDate } = useLocalDate()

  return (
    <span>
      {formatDate({
        date,
        locale,
      })}
    </span>
  )
}
